module.exports = __webpack_public_path__ + "img/fm-f-Path 48@3x.20fbb5b2.png";